import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";

import styled from "styled-components";
import { useTranslation } from "react-i18next";

import * as Icon from "../smartiscity/Icons";
import { getCategoryInfos } from "../utils";

import { useAllContexts } from "../../../hooks/useAllContexts";
import SearchArea from "./SearchArea";
import DataList from "./DataList";

const LeftSidePanel = ({
  data,
  loading,
  selectedItem,
  rightSideBox,
  categoryId,
  selectedCategory,
  handleLeftSide,
  showNewRouteForm,
  refreshComponent,
  refreshMap,
  setSelectedRoute,
}) => {
  const [showLeftSide, setShowLeftSide] = useState(false);
  const [showSensorsPopover, setShowSensorsPopover] = useState(false);

  const { meteo, ameaInfrastructures, sensorTypes, allSensors } =
    useAllContexts();
  const { t } = useTranslation();

  const mapData = useMemo(() => getCategoryInfos(categoryId), [categoryId]);

  useEffect(() => {
    const isVisible = !loading;
    handleLeftSide(isVisible);
    setShowLeftSide(isVisible);
  }, [loading, handleLeftSide]);

  const renderAddress = (address) => {
    const splitted = address.toLowerCase().split(" ");
    let tempAddress = "";

    splitted.forEach((word) => {
      tempAddress += `${word[0].toUpperCase()}${word.slice(1, word.length)} `;
    });
    return tempAddress;
  };

  return (
    <LeftSideWrapper
      $left={showLeftSide ? "0" : "-396px"}
      $top={
        showLeftSide
          ? categoryId === "122"
            ? "50px"
            : "0"
          : categoryId === "122"
          ? "-340px"
          : "-396px"
      }
    >
      <LeftSideContent tabIndex={0}  aria-label="Sensor list, scrollable">
        <SearchArea
          sensorTypes={sensorTypes}
          showPopover={{ get: showSensorsPopover, set: setShowSensorsPopover }}
          refreshComponent={refreshComponent}
          categoryId={categoryId}
          selectedCategory={selectedCategory}
          refreshMap={refreshMap}
        />

        {!showNewRouteForm.get && (
          <LeftSideHeader $bgColor={mapData?.bgColor}>
            <p>
              {categoryId === "122"
                ? `${selectedCategory === "infra" ? "Υποδομές" : "Διαδρομές"} ${
                    mapData?.mapTitle
                  }`
                : categoryId === "1"
                ? renderAddress(t(`environmental.title`))
                : mapData?.mapTitle ?? mapData?.title}
            </p>
          </LeftSideHeader>
        )}

        <DataList
          data={
            categoryId === "12"
              ? data.filter(
                  (item) =>
                    item.details?.length > 0 &&
                    item.mysensor_name !== "HAM1" &&
                    item.mysensor_name !== "HAM2"
                )
              : data
          }
          showNewRouteForm={{ ...showNewRouteForm }}
          mapData={mapData}
          rightSideBox={rightSideBox}
          categoryId={categoryId}
          selectedCategory={selectedCategory}
          selectedItem={selectedItem}
          setSelectedRoute={(item) => {
            setSelectedRoute(item);
          }}
        />
      </LeftSideContent>

      <LeftSideToggleButton
        onClick={() => {
          handleLeftSide(!showLeftSide);
          setShowLeftSide(!showLeftSide);
        }}
      >
        <ToggleArrow
          src={Icon.rightArrow}
          $isLeftSideVisible={showLeftSide}
          alt="Toggle Left Side"
        />
      </LeftSideToggleButton>
    </LeftSideWrapper>
  );
};

export default LeftSidePanel;

const LeftSideWrapper = styled.div`
  position: absolute;
  width: 396px;
  height: calc(100vh - 99px);
  margin-top: 70px;
  background-color: #f5f5f5;
  top: 0;
  left: ${(props) => props.$left};
  z-index: 1;
  transition: left 1s ease, top 1s ease;

  @media only screen and (max-width: 609px) {
    left: unset;
    top: calc(${(props) => props.$top});
    width: 100%;
    height: 400px;
    z-index: 1;
  }

  @media only screen and (min-width: 609px) and (max-width: 908px) {
    top: 55px;
    left: calc(${(props) => props.$left});
  }
`;

const LeftSideToggleButton = styled.div`
  width: 26px;
  height: 52px;
  background-color: #000000e6;
  position: absolute;
  top: 45%;
  right: -26px;
  z-index: 100;
  border-radius: 0 12px 12px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  @media only screen and (max-width: 609px) {
    width: 52px;
    height: 26px;
    bottom: -26px;
    left: 45%;
    top: unset;
    border-radius: 0 0 12px 12px;
  }
`;

const LeftSideContent = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* Internet Explorer and Edge */
  scrollbar-width: none; /* Firefox */
`;

const LeftSideHeader = styled.div`
  width: 100%;
  height: 90px;
  background-color: ${(props) => props.$bgColor};
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ToggleArrow = styled.img`
  transform: ${(props) =>
    props.$isLeftSideVisible ? "rotate(180deg)" : "unset"};

    @media only screen and (max-width: 609px) {
    transform: ${(props) =>
      props.$isLeftSideVisible ? "rotate(-90deg)" : "rotate(90deg)"};
`;
